import { navigate, type PageProps } from 'gatsby';
import React, { useEffect } from 'react';

import * as ROUTES from '@constants/routes';

import ErrorForm from '@views/Authentication/PasswordReset/ErrorForm';
import ResetForm from '@views/Authentication/PasswordReset/ResetForm';
import SentForm from '@views/Authentication/PasswordReset/SentForm';
import SuccessForm from '@views/Authentication/PasswordReset/SuccessForm';

enum ResetPasswordStateParam {
  Error = 'error',
  Reset = 'reset',
  Success = 'success',
  Sent = 'sent',
}

function ResetPasswordStatePage({ params }: PageProps) {
  const state = params.state;
  useEffect(() => {
    if (
      !state ||
      !Object.values<string>(ResetPasswordStateParam).includes(state)
    ) {
      navigate(ROUTES.LOGIN);
    }
  }, [state]);

  switch (state) {
    case ResetPasswordStateParam.Reset:
      return <ResetForm {...params} />;
    case ResetPasswordStateParam.Error:
      return <ErrorForm {...params} />;
    case ResetPasswordStateParam.Success:
      return <SuccessForm {...params} />;
    case ResetPasswordStateParam.Sent:
      return <SentForm {...params} />;
    default:
      return null;
  }
}

export default ResetPasswordStatePage;
